export default "__VITE_ASSET__BqeRZBb3__"